import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=b1cd2b26"
import script from "./SideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=b1cd2b26&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports